import { AnswersProviders, AnswersProviderWithOptions } from '../answers/interfaces'
import { Language, resources } from '../i18n'
import phoneSmallSrc from '../assets/img/phone-small.png'
import phoneMediumSrc from '../assets/img/phone-medium.png'
import phoneLargeSrc from '../assets/img/phone-large.png'
import cameraSmallSrc from '../assets/img/camera-small.png'
import cameraMediumSrc from '../assets/img/camera-medium.png'
import cameraLargeSrc from '../assets/img/camera-large.png'
import memorySmallSrc from '../assets/img/memory-small.png'
import memoryMediumSrc from '../assets/img/memory-medium.png'
import memoryLargeSrc from '../assets/img/memory-large.png'
import bell from '../assets/img/providers/bell.png'
import bellBlue from '../assets/img/providers/bell-blue.png'
import cogeco from '../assets/img/providers/cogeco.png'
import cogecoBlue from '../assets/img/providers/cogeco-blue.png'
import ebox from '../assets/img/providers/ebox.png'
import eboxBlue from '../assets/img/providers/ebox-blue.png'
import fido from '../assets/img/providers/fido.png'
import fidoBlue from '../assets/img/providers/fido-blue.png'
import fizz from '../assets/img/providers/fizz.png'
import fizzBlue from '../assets/img/providers/fizz-blue.png'
import rogers from '../assets/img/providers/rogers.png'
import rogersBlue from '../assets/img/providers/rogers-blue.png'
import telus from '../assets/img/providers/telus.png'
import telusBlue from '../assets/img/providers/telus-blue.png'
import videotron from '../assets/img/providers/videotron.png'
import videotronBlue from '../assets/img/providers/videotron-blue.png'
import virgin from '../assets/img/providers/virgin.png'
import virginBlue from '../assets/img/providers/virgin-blue.png'
import chatr from '../assets/img/providers/chatr.png'
import chatrBlue from '../assets/img/providers/chatr-blue.png'
import easlink from '../assets/img/providers/eastlink.png'
import easlinkBlue from '../assets/img/providers/eastlink-blue.png'
import freedomMobile from '../assets/img/providers/freedom.png'
import freedomMobileBlue from '../assets/img/providers/freedom-blue.png'
import koodo from '../assets/img/providers/koodo.png'
import koodoBlue from '../assets/img/providers/koodo-blue.png'
import publicMobile from '../assets/img/providers/public.png'
import publicMobileBlue from '../assets/img/providers/public-blue.png'
import sasktel from '../assets/img/providers/sasktel.png'
import sasktelBlue from '../assets/img/providers/sasktel-blue.png'
import luckyMobile from '../assets/img/providers/lucky.png'
import luckyMobileBlue from '../assets/img/providers/lucky-blue.png'
import giftSrc from '../assets/img/byod-cell.png'
import smartSrc from '../assets/img/new-cell.png'
import speedSearchSrc from '../assets/img/speed-search.png'
import needHelpSrc from '../assets/img/need-help.png'
import howManyMinutes from '../assets/img/how-many-minutes.png'
import howManyPeopleSimultaneously from '../assets/img/how-many-people-use-internet-at-home.png'
import howManyPeopleWorkFromHome from '../assets/img/internet-travail.png'
import streamingVideoQuality from '../assets/img/internet-tv.png'
import onlineGaming from '../assets/img/internet-jeux.png'
import internetSpeed from '../assets/img/internet-speedtest.png'
import findhome from '../assets/img/internet-find-home.png'
// import howManyDevices from '../assets/img/how-many-devices.png'
import transparentBlackSpinner from '../assets/gifs/spinners/transparent-black-ph-spinner.gif'
import transparentWhiteSpinner from '../assets/gifs/spinners/transparent-white-ph-spinner.gif'
import transparentDarkBlueSpinner from '../assets/gifs/spinners/transparent-dark-blue-ph-spinner.gif'
import finder from '../assets/logo/finder.png'
import finderDarkMode from '../assets/logo/finder-dark-mode.png'
import mobilesyrup from '../assets/logo/mobilesyrup.png'
import ratehub from '../assets/logo/ratehub.png'
import francoischarron from '../assets/logo/francoischarron.png'
import protegezvous from '../assets/logo/protegezvous.png'
import lactualite from '../assets/logo/logo-dollarsetcents.png'
import planhub from '../assets/logo/planhub.png'
import redflagdeals from '../assets/logo/redflagdeals.png'
import alberta from '../assets/img/provinces/AB.svg'
import britishColumbia from '../assets/img/provinces/BC.svg'
import manitoba from '../assets/img/provinces/MB.svg'
import newBrunswick from '../assets/img/provinces/NB.svg'
import newfoundlandAndLabrador from '../assets/img/provinces/NL.svg'
import northwestTerritories from '../assets/img/provinces/NT.svg'
import nunavut from '../assets/img/provinces/NU.svg'
import ontario from '../assets/img/provinces/ON.svg'
import princeEdwardIsland from '../assets/img/provinces/PE.svg'
import quebec from '../assets/img/provinces/QC.svg'
import saskatchewan from '../assets/img/provinces/SK.svg'
import yukon from '../assets/img/provinces/YK.svg'
import novascotia from '../assets/img/provinces/NS.svg'
import cellPhoneState1 from '../assets/img/mobile-plan.svg'
import cellPhoneState2 from '../assets/img/mobile-plan-hover.svg'
import internetState1 from '../assets/img/internet-plan.svg'
import internetState2 from '../assets/img/internet-plan-hover.svg'
import planhubConsentLogo from '../assets/logo/default.png'
import review1 from '../assets/img/reviews/review-1.png'
import review3 from '../assets/img/reviews/review-3.png'
import review4 from '../assets/img/reviews/review-4.png'
import review5 from '../assets/img/reviews/review-5.png'
import review6 from '../assets/img/reviews/review-6.png'
import review7 from '../assets/img/reviews/review-7.png'
import review9 from '../assets/img/reviews/review-9.png'
import review10 from '../assets/img/reviews/review-10.png'
import review11 from '../assets/img/reviews/review-11.png'
import reviewContestEn from '../assets/img/reviews/review-contest-en.png'
import reviewContestFr from '../assets/img/reviews/review-contest-fr.png'
import addressLocation from '../assets/img/address-location.png'
import lead1 from '../assets/img/lead/lead-1.png'
import lead3 from '../assets/img/lead/lead-3.png'
import lead4 from '../assets/img/lead/lead-4.png'
import alert1 from '../assets/img/alerts/alertes-1.png'
import alert2 from '../assets/img/alerts/alertes-2.png'
import alert3 from '../assets/img/alerts/alertes-3.png'
import alert4 from '../assets/img/alerts/alertes-4.png'
import alertSearch from '../assets/img/alerts/alert_search.png'
import alertSearchLoaded from '../assets/img/alerts/alert_search_loaded.png'
import alertYourPlan from '../assets/img/alerts/alert_your_plan.png'
import alertYourPlanLoaded from '../assets/img/alerts/alert_your_plan_loaded.png'
import ticket1 from '../assets/img/ticket/somethingwrong-1.png'
import ticket3 from '../assets/img/ticket/somethingwrong-3.png'
import ticket4 from '../assets/img/ticket/somethingwrong-4.png'
import firstName from '../assets/img/first-name.png'
import travel from '../assets/img/visitors/travel.png'
import move from '../assets/img/visitors/move.png'
import migrating from '../assets/img/visitors/immigration.png'
import liveInCanada from '../assets/img/visitors/move.png'
import dontknow from '../assets/img/visitors/dontknow.svg'
import b2bEmail from '../assets/img/b2b/b2bEmail.png'
import b2bPhone from '../assets/img/b2b/b2bPhone.png'
import b2bFirstName from '../assets/img/b2b/b2bFirstName.png'
import b2bLastName from '../assets/img/b2b/b2bLastName.png'
import b2bCompany from '../assets/img/b2b/b2bCompany.png'
import allPhones from '../assets/img/all-phones.svg'
import inStoreSupport from '../assets/img/in-store-support.svg'
import googlePlay from '../assets/img/google-play.svg'
import deviceStepQ from '../assets/img/device-step-q.png'

export enum Steps {
  PROVINCE = 'province',
  HOW_MANY_CALLING_MINUTES = 'how-many-calling-minutes',
  HOW_MUCH_DATA = 'how-much-data',
  BUY_OR_BRING_PHONE = 'buy-or-bring-phone',
  CHOOSE_PHONE_OS = 'choose-phone-os',
  CHOOSE_PHONE_CONDITION = 'choose-phone-condition',
  CHOOSE_PHONE_SIZE = 'choose-phone-size',
  CHOOSE_PREFERRED_DEVICES_BRANDS = 'choose-preferred-devices-brands',
  CHOOSE_PREFERRED_DEVICES_BRANDS_ANDROID = 'choose-preferred-devices-brands-android',
  CHOOSE_PREFERRED_DEVICES_BRANDS_PROPRIETARY = 'choose-preferred-devices-brands-proprietary',
  CHOOSE_PHONE_CAMERA = 'choose-phone-camera',
  CHOOSE_PHONE_MEMORY = 'choose-phone-memory',
  CHOOSE_WIFI_CALLING = 'choose-wifi-calling',
  CHOOSE_PHONE_FROM_LIST = 'choose-phone-from-list',
  INTERNET_USAGE = 'internet-usage',
  INTERNET_USAGE_INFO_ONLY = 'internet-usage-info-only',
  POSTAL_CODE = 'postal-code',
  POSTAL_CODE_INTERNET = 'postal-code-internet',
  POSTAL_CODE_B2B = 'postal-code-b2b',
  ARE_YOU_MOVING = 'are-you-moving',
  HOW_MANY_PEOPLE_SIMULTANEOUSLY = 'how-many-people-simultaneously',
  HOW_MANY_DEVICES = 'how-many-devices',
  HOW_MANY_PEOPLE_WORKING_FROM_HOME = 'how-many-people-work-from-home',
  STREAMING_VIDEO_QUALITY = 'streaming-video-quality',
  ONLINE_GAMING = 'online-gaming',
  LARGE_FILES_DOWNLOAD_FREQUENCY = 'large-files-download-frequency',
  CURRENT_PROVIDER = 'current-provider',
  CURRENT_PROVIDER_MOBILE = 'current-provider-mobile',
  CURRENT_PROVIDER_INTERNET = 'current-provider-internet',
  CURRENT_PROVIDER_INTERNET_B2B = 'current-provider-internet-b2b',
  CURRENT_PROVIDER_MOBILE_B2B = 'current-provider-mobile-b2b',
  CURRENT_PROVIDER_MOBILE_LEAD = 'current-provider-mobile-lead',
  CURRENT_PROVIDER_INTERNET_LEAD = 'current-provider-internet-lead',
  CURRENT_PROVIDER_MOBILE_EMAIL_COLLECTOR = 'current-provider-mobile-email-collector',
  CURRENT_PROVIDER_INTERNET_EMAIL_COLLECTOR = 'current-provider-internet-email-collector',
  CURRENT_PROVIDER_INTERNET_MOBILE = 'current-provider-internet-mobile',
  MONTHLY_USAGE = 'monthly-usage',
  DOWNLOAD_SPEED = 'download-speed',
  PHONE_MODEL_ID = 'phone-model-id',
  DONE = 'done',
  INTERNET_SPEED_OR_HELP = 'internetSpeed-or-help',
  INTERNET_SPEED = 'internet-speed',
  NAME_NICKNAME = 'name-nickname',
  SELECT_CURRENT_PROVIDER = 'select-current-provider',
  ADDRESS_LOCATION = 'address-location',
  START_RATING = 'start-rating',
  CONFIRM_REVIEW = 'confirm-review',
  CONFIRM_VISITOR = 'confirm-visitor',
  CONFIRM_COMMUNICATION = 'confirm-communication',
  NETWORK = 'network',
  BILL = 'bill',
  DIGITAL_EXPERIENCE = 'digital-experience',
  ONBOARDING_EXPERIENCE = 'onboarding-experience',
  CUSTOMER_SERVICE = 'customer-service',
  RECOMMEND_PROVIDER = 'recommend-provider',
  FINAL_WORD = 'final-word',
  FINAL_WORD_REFERRAL_CODE = 'final-word-referral-code',
  FINAL_WORD_B2B = 'final-word-b2b',
  CONFIRM = 'confirm',
  EMAIL_ADDRESS = 'email-address',
  EMAIL_ADDRESS_OPTIONAL = 'email-address-optional',
  EMAIL_ADDRESS_OPTIONAL_WITH_ALERT = 'email-address-optional-with-alert',
  EMAIL_ADDRESS_NEWSLETTER = 'email-address-newsletter',
  EMAIL_ADDRESS_LEAD = 'email-address-lead',
  EMAIL_ADDRESS_ALERT = 'email-address-alert',
  EMAIL_ADDRESS_B2B = 'email-address-b2b',
  START_LEAD = 'start-lead',
  FIRST_NAME = 'first-name',
  FIRST_NAME_B2B = 'first-name-b2b',
  LAST_NAME = 'last-name',
  LAST_NAME_B2B = 'last-name-b2b',
  PHONE_NUMBER = 'phone-number',
  PHONE_NUMBER_B2B = 'phone-number-b2b',
  CONFIRM_LEAD = 'confirm-lead',
  CONFIRM_NEWSLETTER = 'confirm-newsletter',
  CONFIRM_NEWSLETTERS = 'confirm-newsletters',
  CONFIRM_CHECK_AVAILABILITY = 'confirm-check-availability',
  START_MOBILE_ALERT = 'start-alert',
  START_INTERNET_ALERT = 'start-alert',
  START_FIBER_OPTIC_ALERT = 'start-fiber-optic-alert',
  CONFIRM_ALERT = 'confirm-alert',
  CONFIRM_ALERT_FIBER_OPTIC = 'confirm-fiber-optic-alert',
  OPTIONS_ALERT = 'options-alert',
  CURRENT_MONTHLY_PAYMENT = 'current-monthly-payment',
  // DESIRED_PAYMENT = 'desired-payment',
  SAVINGS_PERCENT = 'savings-percent',
  THANKS = 'thanks',
  THANKS_NEWSLETTER = 'thanks-newsletter',
  THANKS_EMAIL_COLLECTOR = 'thanks-email-collector',
  THANKS_GOVERNMENT = 'thanks-government',
  PROVIDER_AVAILABILITY = 'provider-availability',
  VALUE_CUSTOMER_OPINIONS = 'value-customer-opinions',
  VALUE_COST_EFFICIENCY = 'value-cost-efficiency',
  VALUE_PRICE = 'value-price',
  VALUE_THE_MOST_CHOICES_1 = 'value-the-most-choices-1',
  VALUE_THE_MOST_CHOICES_2 = 'value-the-most-choices-2',
  HOME_PHONE_NEEDED = 'home_phone_needed',
  BIG_ENTREPRISE = 'big-entreprise',
  BIG_ENTREPRISE2 = 'big-entreprise2',
  SLIDER_DATA = 'slider-data',
  SLIDER_DATA_AMOUNT = 'slider-data-amount',
  DECISION_MOBILE_INTERNET = 'decision-mobile-internet',
  DECISION_ALERT_COMMON_PRICE_DROP = 'decision-alert-common-price-drop',
  DECISION_MOBILE_INTERNET_REVIEW = 'decision-mobile-internet-review',
  EMAIL_ADDRESS_FIBER_OPTIC_ALERT = 'EMAIL_ADDRESS_FIBER_OPTIC_ALERT',
  CONFIRM_FIBER_OPTIC_ALERT = 'fiber-optic',
  CALLING_OPTIONS = 'calling-options',
  DATA_OPTIONS = 'data-options',
  EMAIL_ADDRESS_TICKET = 'email-address-ticket',
  TICKET_INITIAL_INFO = 'ticket-initial-info',
  COMMENT_TICKET = 'comment-ticket',
  BUY_OR_BRING_PHONE_QUICK_SEARCH = 'buy-or-bring-phone-quick-search',
  HOW_MUCH_DATA_ALERT_OBSERVER = 'how-much-data-alert-observer',
  HOW_MUCH_PAYMENT = 'how-much-payment',
  HOW_MUCH_PAYMENT_ALERT_OBSERVER = 'how-much-payment-alert-observer',
  CURRENT_INTERNET_SPEED_ALERT_OBSERVER = 'current-internet-speed-alert-observer',
  POSTAL_CODE_ALERT_OBSERVER = 'postal-code-alert-observer',
  SLIDER_DATA_INTERNET_SPEED = 'slider-data-internet-speed',
  START_VISITOR = 'start-visitor',
  DATE_PICKER = 'date-picker',
  INSTALLATION_DATE_PICKER = 'installation-date-picker',
  START_QUESTIONNAIRE = 'start-questionnaire',
  VISIT_ESIM = 'visit-esim',
  THANKS_VISITOR = 'thanks-visitor',
  THANKS_COUNTRY = 'thanks-country',
  THANKS_B2B = 'thanks-b2b',
  THANKS_FIBER_OPTIC_ALERT = 'thanks-fiber-optic-alert',
  COUNTRY = 'country',
  EMAIL_ADDRESS_PAGE_GO = 'email-address-page-go',
  COMPANY_NAME = 'company-name',
  BUSINESS_CONNECTIVITY = 'business-connectivity',
  HOW_MANY_CELLPHONE_LINES = 'how-many-cellphone-lines',
  CANADA_US_COVERAGE = 'canada-us-coverage',
  BOOK_A_MEEETING = 'book-a-meeting',
  COVERAGE = 'coverage',
  BUSINESS_OR_NOT_MOBILE = 'business-or-not-mobile',
  BUSINESS_OR_NOT_INTERNET = 'business-or-not-internet',
  NEW_CLIENT_VERIFICATION = 'new-client-verification',
  MOBILE_PROVIDER_COLLECTOR_EMAIL = 'mobile-provider-collector-email',
  EMAIL_ADDRESS_EMAIL_COLLECTOR = 'email-address-email-collector',
  PHONE_ID = 'phone-id',
  CHOICE_INTERNET_MOBILE_TV = 'choice-internet-mobile-tv',
  CHOOSE_PHONE_PLAN = 'choose-phone-plan',
  TRANSFERRING_SERVICE = 'transferring-service',
  TRANSFER_PROVIDER = 'transfer-provider',
  INSTALLATION_DATE = 'installation-date',
  CONFIGURATION_TV = 'configuration-tv',
  CHOOSE_CHANNELS = 'choose-channels',
  IN_STORE_SUPPORT = 'in-store-support',
  TV_NUMBER = 'tv-number',
  TV_TYPE = 'tv-type',
  TECHNICIAN_TIME = 'technician-time',
  ADDRESS_LOCATION_MEKTEL = 'address-location-mektel',
  FINAL_WORD_MEKTEL = 'final-word-mektel',
  SELECT_CURRENT_PROVIDER_LEAD_MEKTEL = 'select-current-provider-lead-mektel',
  SERVICE_TRANSFERRED = 'service-transferred',
  TRANSFER_INTERNET = 'transfer-internet',
  PHONE_RESIDENTIAL = 'phone-residential',
  KEEP_CURRENT_NUMBER = 'keep-current-number',
  ANDROID_APP = 'android-app',
}

// These steps are formed in order to update the question used from common steps. Also to be able to add the corresponding text (EX: ..._question, ..._tip)
export enum UpdatedSteps {
  THANKS_RATING = 'thanks-rating',
  THANKS_LEAD = 'thanks-lead',
  THANKS_ALERT_MOBILE = 'thanks-alert-mobile',
  THANKS_ALERT_INTERNET = 'thanks-alert-internet',
  THANKS_ALERT_COMPETITION = 'thanks-alert-competition',
  ADDRESS_LOCATION_INTERNET = 'address-location-internet',
  ADDRESS_LOCATION_LEAD = 'address-location-lead',
  ADDRESS_LOCATION_B2B = 'address-location-B2B',
  INTERNET_SPEED_WITH_SLIDE = 'internet-speed-with-slide',
  THANKS_TICKET = 'thanks-ticket',
  EMAIL_ADDRESS_VISITOR = 'email-address-visitor',
  EMAIL_ADDRESS_COUNTRY = 'email-address-country',
  EMAIL_ADDRESS_REVIEW_CONTEST = 'email-address-review-contest',
  PROVINCES_VISITOR = 'provinces-visitor',
}

// These steps are formed in order to be used as testing steps
export enum TestingSteps {
  STEP_1 = 'step-1',
  STEP_2 = 'step-2',
  STEP_3 = 'step-3',
  STEP_4 = 'step-4',
}

export type AllSteps = Steps | UpdatedSteps | TestingSteps

export enum Images {
  BRING_PHONE = 'byod_cell',
  PURCHASE_PHONE = 'new_cell',
  PHONE_SMALL = 'phone-small',
  PHONE_MEDIUM = 'phone-medium',
  PHONE_LARGE = 'phone-large',
  CAMERA_SMALL = 'camera-small',
  CAMERA_MEDIUM = 'camera-medium',
  CAMERA_LARGE = 'camera-large',
  MEMORY_SMALL = 'memory-small',
  MEMORY_MEDIUM = 'memory-medium',
  MEMORY_LARGE = 'memory-large',
  SPEED_SEARCH = 'speed-search',
  NEED_HELP = 'help',
  CELL_PHONE_STATE_1 = 'cellphone-state-1',
  CELL_PHONE_STATE_2 = 'cellphone-state-2',
  INTERNET_STATE_1 = 'internet-state-1',
  INTERNET_STATE_2 = 'internet-state-2',
  HOW_MANY_MINUTES = 'how-many-minutes',
  HOW_MANY_PEOPLE_SIMULTANEOUSLY = 'how-many-people-simultaneously',
  HOW_MANY_DEVICES = 'how-many-devices',
  HOW_MANY_PEOPLE_WORKING_FROM_HOME = 'how-many-people-work-from-home',
  STREAMING_VIDEO_QUALITY = 'streaming-video-quality',
  ONLINE_GAMING = 'online-gaming',
  INTERNET_SPEED = 'internet-speed',
  FIND_HOME = 'find-home',
  REVIEW_1 = 'review-1',
  REVIEW_3 = 'review-3',
  REVIEW_4 = 'review-4',
  REVIEW_5 = 'review-5',
  REVIEW_6 = 'review-6',
  REVIEW_7 = 'review-7',
  REVIEW_9 = 'review-9',
  REVIEW_10 = 'review-10',
  REVIEW_11 = 'review-11',
  REVIEW_CONTEST_EN = 'review-contest-en',
  REVIEW_CONTEST_FR = 'review-contest-fr',
  ADDRESS_LOCATION = 'address-location',
  LEAD_1 = 'lead-1',
  LEAD_3 = 'lead-3',
  LEAD_4 = 'lead-4',
  ALERT_1 = 'alerte-1',
  ALERT_2 = 'alerte-2',
  ALERT_3 = 'alerte-3',
  ALERT_4 = 'alerte-4',
  ALERT_SEARCH = 'alert-search',
  ALERT_SEARCH_LOADED = 'alert-search-loaded',
  ALERT_YOUR_PLAN = 'alert-your-plan',
  ALERT_YOUR_PLAN_LOADED = 'alert-your-plan-loaded',
  TICKET_1 = 'ticket-1',
  TICKET_3 = 'ticket-3',
  TICKET_4 = 'ticket-4',
  FIRST_NAME = 'first-name',
  LAST_NAME = 'last-name',
  TRAVEL = 'travel',
  MIGRATING = 'migrating',
  LIVE_IN_CANADA = 'live-in-canada',
  DONT_KNOW = 'dontknow',
  MOVE = 'move',
  B2B_EMAIL = 'b2b-email',
  B2B_PHONE = 'b2b-phone',
  B2B_FIRST_NAME = 'b2b-first-name',
  B2B_LAST_NAME = 'b2b-LAST-name',
  B2B_COMPANY = 'b2b-company',
  ALL_PHONES = 'all-phones',
  DEVICE_STEP_Q = 'device-step-q',
  IN_STORE_SUPPORT = 'in-store-support',
  GOOGLE_PLAY = 'google-play',
}

export enum LogoImages {
  BELL = 'bell',
  BELL_BLUE = 'bell-blue',
  ROGERS = 'rogers',
  ROGERS_BLUE = 'rogers-blue',
  TELUS = 'telus',
  TELUS_BLUE = 'telus-blue',
  VIRGIN = 'virgin',
  VIRGIN_BLUE = 'virgin-blue',
  FIDO = 'fido',
  FIDO_BLUE = 'fido-blue',
  FIZZ = 'fizz',
  FIZZ_BLUE = 'fizz-blue',
  VIDEOTRON = 'videotron',
  VIDEOTRON_BLUE = 'videotron-blue',
  COGECO = 'cogeco',
  COGECO_BLUE = 'cogeco-blue',
  EBOX = 'ebox',
  EBOX_BLUE = 'ebox-blue',
  CHATR = 'chatr',
  CHATR_BLUE = 'chatr-blue',
  EASTLINK = 'eastlink',
  EASTLINK_BLUE = 'eastlink-blue',
  FREEDOM_MOBILE = 'freedom-mobile',
  FREEDOM_MOBILE_BLUE = 'freedom-mobile-blue',
  KOODO = 'koodo',
  KOODO_BLUE = 'koodo-blue',
  PUBLIC_MOBILE = 'public-mobile',
  PUBLIC_MOBILE_BLUE = 'public-mobile-blue',
  SASKTEL = 'sasktel',
  SASKTEL_BLUE = 'sasktel-blue',
  LUCKY_MOBILE = 'lucky-mobile',
  LUCKY_MOBILE_BLUE = 'lucky-mobile-blue',
  ALBERTA = 'alberta',
  BRITISH_COLUMBIA = 'british-columbia',
  MANITOBA = 'manitoba',
  NEW_BRUNSWICK = 'new-brunswick',
  NEWFOUNDLAND_AND_LABRADOR = 'newfoundland-and-labrador',
  NEWFOUNDLAND_AND_LABRADOR_VARIANT_1 = 'newfoundland-labrador',
  NUNAVUT = 'nunavut',
  NORTHWEST_TERRITORIES = 'northwest-territories',
  ONTARIO = 'ontario',
  PRINCE_EDWARD_ISLAND = 'prince-edward-island',
  PRINCE_EDWARD_ISLAND_VARIANt_1 = 'prince-edward',
  QUEBEC = 'quebec',
  SASKATCHEWAN = 'saskatchewan',
  YUKON = 'yukon',
  NOVA_SCOTIA = 'nova-scotia',
  CELL_PHONE_STATE_1 = 'cellphone-state-1',
  CELL_PHONE_STATE_2 = 'cellphone-state-2',
  INTERNET_STATE_1 = 'internet-state-1',
  INTERNET_STATE_2 = 'internet-state-2',
  DONT_KNOW = 'dontknow',
  ALERT_SEARCH = 'alert-search',
  ALERT_SEARCH_LOADED = 'alert-search-loaded',
  ALERT_YOUR_PLAN = 'alert-your-plan',
  ALERT_YOUR_PLAN_LOADED = 'alert-your-plan-loaded',
}

export enum ProvinceFlagImages {
  ALBERTA = 'alberta',
  BRITISH_COLUMBIA = 'british-columbia',
  MANITOBA = 'manitoba',
  NEW_BRUNSWICK = 'new-brunswick',
  NEWFOUNDLAND_AND_LABRADOR = 'newfoundland-and-labrador',
  NUNAVUT = 'nunavut',
  NORTHWEST_TERRITORIES = 'northwest-territories',
  ONTARIO = 'ontario',
  PRINCE_EDWARD_ISLAND = 'prince-edward-island',
  QUEBEC = 'quebec',
  SASKATCHEWAN = 'saskatchewan',
  YUKON = 'yukon',
  NOVA_SCOTIA = 'nova-scotia',
}

export enum LogosBrand {
  MOBILESYRUP = 'mobilesyrup',
  RATEHUB = 'ratehub',
  FRANCOISCHARRON = 'francoischarron',
  PROTEGEZVOUS = 'protegezvous',
  LACTUALITE = 'lactualite',
  PLANHUB = 'planhub',
  REDFLAGDEALS = 'redflagdeals',
  FINDER = 'finder',
  FINDER_DARK_MODE = 'finder-dark-mode',
  FIZZ = 'fizz',
  PLANHUB_CONSENT = 'planhub-consent',
}

export enum ProviderSlugs {
  BELL = 'bell',
  FIBRESTREAM = 'fibrestream',
  ROGERS = 'rogers',
  EASTLINK = 'eastlink',
  TELUS = 'telus',
}

export enum HostName {
  MOBILESYRUP = 'www.mobilesyrup.planhub.ca',
  RATEHUB = 'www.ratehub.planhub.ca',
  FRANCOISCHARRON = 'www.francoischarron.planhub.ca',
  PROTEGEZVOUS = 'www.protegezvous.planhub.ca',
  LACTUALITE = 'www.lactualite.planhub.ca',
  PLANHUB = 'www.planhub.ca',
  REDFLAGDEALS = 'www.redflagdeals.planhub.ca',
  FINDER = 'finder',
  FINDER_DARK_MODE = 'finder-dark-mode',
  FIZZ = 'fizz',
  LOCALHOST = 'localhost',
  PLANHUB_CONSENT = 'planhub-consent',
}

export enum LoadingGifs {
  BLACK = 'black',
  DARK_BLUE = 'dark-blue',
  WHITE = 'white',
}

export const provinceFlagImageMap: Record<string, string> = {
  [ProvinceFlagImages.ALBERTA]: alberta,
  [ProvinceFlagImages.BRITISH_COLUMBIA]: britishColumbia,
  [ProvinceFlagImages.MANITOBA]: manitoba,
  [ProvinceFlagImages.NEW_BRUNSWICK]: newBrunswick,
  [ProvinceFlagImages.NEWFOUNDLAND_AND_LABRADOR]: newfoundlandAndLabrador,
  [ProvinceFlagImages.NUNAVUT]: nunavut,
  [ProvinceFlagImages.NORTHWEST_TERRITORIES]: northwestTerritories,
  [ProvinceFlagImages.ONTARIO]: ontario,
  [ProvinceFlagImages.PRINCE_EDWARD_ISLAND]: princeEdwardIsland,
  [ProvinceFlagImages.QUEBEC]: quebec,
  [ProvinceFlagImages.SASKATCHEWAN]: saskatchewan,
  [ProvinceFlagImages.YUKON]: yukon,
  [ProvinceFlagImages.NOVA_SCOTIA]: novascotia,
}

export const cardImageMap: Record<string, string> = {
  gift: giftSrc,
  smart: smartSrc,
  [Images.SPEED_SEARCH]: speedSearchSrc,
  [Images.NEED_HELP]: needHelpSrc,
  [Images.CELL_PHONE_STATE_1]: cellPhoneState1,
  [Images.CELL_PHONE_STATE_2]: cellPhoneState2,
  [Images.INTERNET_STATE_1]: internetState1,
  [Images.INTERNET_STATE_2]: internetState2,
  [Images.PURCHASE_PHONE]: smartSrc,
  [Images.BRING_PHONE]: giftSrc,
  [Images.HOW_MANY_MINUTES]: howManyMinutes,
  [Images.HOW_MANY_PEOPLE_SIMULTANEOUSLY]: howManyPeopleSimultaneously,
  [Images.HOW_MANY_PEOPLE_WORKING_FROM_HOME]: howManyPeopleWorkFromHome,
  [Images.STREAMING_VIDEO_QUALITY]: streamingVideoQuality,
  [Images.ONLINE_GAMING]: onlineGaming,
  [Images.INTERNET_SPEED]: internetSpeed,
  [Images.FIND_HOME]: findhome,
  [Images.REVIEW_1]: review1,
  [Images.REVIEW_3]: review3,
  [Images.REVIEW_4]: review4,
  [Images.REVIEW_5]: review5,
  [Images.REVIEW_6]: review6,
  [Images.REVIEW_7]: review7,
  [Images.REVIEW_9]: review9,
  [Images.REVIEW_10]: review10,
  [Images.REVIEW_11]: review11,
  [Images.REVIEW_CONTEST_EN]: reviewContestEn,
  [Images.REVIEW_CONTEST_FR]: reviewContestFr,
  [Images.ADDRESS_LOCATION]: addressLocation,
  [Images.LEAD_1]: lead1,
  [Images.LEAD_3]: lead3,
  [Images.LEAD_4]: lead4,
  [Images.ALERT_1]: alert1,
  [Images.ALERT_2]: alert2,
  [Images.ALERT_3]: alert3,
  [Images.ALERT_4]: alert4,
  [Images.ALERT_SEARCH]: alertSearch,
  [Images.ALERT_SEARCH_LOADED]: alertSearchLoaded,
  [Images.ALERT_YOUR_PLAN]: alertYourPlan,
  [Images.ALERT_YOUR_PLAN_LOADED]: alertYourPlanLoaded,
  [Images.TICKET_1]: ticket1,
  [Images.TICKET_3]: ticket3,
  [Images.TICKET_4]: ticket4,
  [Images.FIRST_NAME]: firstName,
  [Images.LAST_NAME]: firstName,
  [Images.TRAVEL]: travel,
  [Images.MIGRATING]: migrating,
  [Images.LIVE_IN_CANADA]: liveInCanada,
  [Images.DONT_KNOW]: dontknow,
  [Images.MOVE]: move,
  [Images.B2B_EMAIL]: b2bEmail,
  [Images.B2B_PHONE]: b2bPhone,
  [Images.B2B_FIRST_NAME]: b2bFirstName,
  [Images.B2B_LAST_NAME]: b2bLastName,
  [Images.B2B_COMPANY]: b2bCompany,
  [Images.ALL_PHONES]: allPhones,
  [Images.DEVICE_STEP_Q]: deviceStepQ,
  [Images.IN_STORE_SUPPORT]: inStoreSupport,
  [Images.GOOGLE_PLAY]: googlePlay,
}

export const phoneImageMap: Record<string, string> = {
  [Images.PHONE_SMALL]: phoneSmallSrc,
  [Images.PHONE_MEDIUM]: phoneMediumSrc,
  [Images.PHONE_LARGE]: phoneLargeSrc,
  [Images.CAMERA_SMALL]: cameraSmallSrc,
  [Images.CAMERA_MEDIUM]: cameraMediumSrc,
  [Images.CAMERA_LARGE]: cameraLargeSrc,
  [Images.MEMORY_SMALL]: memorySmallSrc,
  [Images.MEMORY_MEDIUM]: memoryMediumSrc,
  [Images.MEMORY_LARGE]: memoryLargeSrc,
}

export const logoImageMap: Record<string, string> = {
  [LogoImages.BELL]: bell,
  [LogoImages.BELL_BLUE]: bellBlue,
  [LogoImages.COGECO]: cogeco,
  [LogoImages.COGECO_BLUE]: cogecoBlue,
  [LogoImages.EBOX]: ebox,
  [LogoImages.EBOX_BLUE]: eboxBlue,
  [LogoImages.FIDO]: fido,
  [LogoImages.FIDO_BLUE]: fidoBlue,
  [LogoImages.FIZZ]: fizz,
  [LogoImages.FIZZ_BLUE]: fizzBlue,
  [LogoImages.ROGERS]: rogers,
  [LogoImages.ROGERS_BLUE]: rogersBlue,
  [LogoImages.TELUS]: telus,
  [LogoImages.TELUS_BLUE]: telusBlue,
  [LogoImages.VIDEOTRON]: videotron,
  [LogoImages.VIDEOTRON_BLUE]: videotronBlue,
  [LogoImages.VIRGIN]: virgin,
  [LogoImages.VIRGIN_BLUE]: virginBlue,
  [LogoImages.CHATR]: chatr,
  [LogoImages.CHATR_BLUE]: chatrBlue,
  [LogoImages.EASTLINK]: easlink,
  [LogoImages.EASTLINK_BLUE]: easlinkBlue,
  [LogoImages.FREEDOM_MOBILE]: freedomMobile,
  [LogoImages.FREEDOM_MOBILE_BLUE]: freedomMobileBlue,
  [LogoImages.KOODO]: koodo,
  [LogoImages.KOODO_BLUE]: koodoBlue,
  [LogoImages.PUBLIC_MOBILE]: publicMobile,
  [LogoImages.PUBLIC_MOBILE_BLUE]: publicMobileBlue,
  [LogoImages.SASKTEL]: sasktel,
  [LogoImages.SASKTEL_BLUE]: sasktelBlue,
  [LogoImages.LUCKY_MOBILE]: luckyMobile,
  [LogoImages.LUCKY_MOBILE_BLUE]: luckyMobileBlue,
  [LogoImages.ALBERTA]: alberta,
  [LogoImages.BRITISH_COLUMBIA]: britishColumbia,
  [LogoImages.MANITOBA]: manitoba,
  [LogoImages.NEW_BRUNSWICK]: newBrunswick,
  [LogoImages.NEWFOUNDLAND_AND_LABRADOR]: newfoundlandAndLabrador,
  [LogoImages.NEWFOUNDLAND_AND_LABRADOR_VARIANT_1]: newfoundlandAndLabrador,
  [LogoImages.NUNAVUT]: nunavut,
  [LogoImages.NORTHWEST_TERRITORIES]: northwestTerritories,
  [LogoImages.ONTARIO]: ontario,
  [LogoImages.PRINCE_EDWARD_ISLAND]: princeEdwardIsland,
  [LogoImages.PRINCE_EDWARD_ISLAND_VARIANt_1]: princeEdwardIsland,
  [LogoImages.QUEBEC]: quebec,
  [LogoImages.SASKATCHEWAN]: saskatchewan,
  [LogoImages.YUKON]: yukon,
  [LogoImages.NOVA_SCOTIA]: novascotia,
  [LogoImages.CELL_PHONE_STATE_1]: cellPhoneState1,
  [LogoImages.CELL_PHONE_STATE_2]: cellPhoneState2,
  [LogoImages.INTERNET_STATE_1]: internetState1,
  [LogoImages.INTERNET_STATE_2]: internetState2,
  [Images.DEVICE_STEP_Q]: deviceStepQ,
  [LogoImages.DONT_KNOW]: dontknow,
  [LogoImages.ALERT_SEARCH]: alertSearch,
  [LogoImages.ALERT_SEARCH_LOADED]: alertSearchLoaded,
  [LogoImages.ALERT_YOUR_PLAN]: alertYourPlan,
  [LogoImages.ALERT_YOUR_PLAN_LOADED]: alertYourPlanLoaded,
}

export const LogosBrandMap: Record<string, string> = {
  [HostName.MOBILESYRUP]: LogosBrand.MOBILESYRUP,
  [HostName.RATEHUB]: LogosBrand.RATEHUB,
  [HostName.FRANCOISCHARRON]: LogosBrand.FRANCOISCHARRON,
  [HostName.PROTEGEZVOUS]: LogosBrand.PROTEGEZVOUS,
  [HostName.LACTUALITE]: LogosBrand.LACTUALITE,
  [HostName.PLANHUB]: LogosBrand.PLANHUB,
  [HostName.REDFLAGDEALS]: LogosBrand.REDFLAGDEALS,
  [HostName.FINDER]: LogosBrand.FINDER,
  [HostName.FINDER_DARK_MODE]: LogosBrand.FINDER_DARK_MODE,
  [HostName.FIZZ]: LogosBrand.FIZZ,
  [HostName.LOCALHOST]: LogosBrand.PLANHUB,
  [HostName.PLANHUB_CONSENT]: LogosBrand.PLANHUB_CONSENT,
}

export const hostNameMap: Record<string, string> = {
  [HostName.MOBILESYRUP]: mobilesyrup,
  [HostName.RATEHUB]: ratehub,
  [HostName.FRANCOISCHARRON]: francoischarron,
  [HostName.PROTEGEZVOUS]: protegezvous,
  [HostName.LACTUALITE]: lactualite,
  [HostName.PLANHUB]: planhub,
  [HostName.REDFLAGDEALS]: redflagdeals,
  [HostName.FINDER]: finder,
  [HostName.FINDER_DARK_MODE]: finderDarkMode,
  [HostName.FIZZ]: fizz,
  [HostName.LOCALHOST]: planhub,
  [HostName.PLANHUB_CONSENT]: planhubConsentLogo,
}

export const hostNameWithLocaleMap: Record<string, string> = {
  [HostName.LACTUALITE]: lactualite,
  [HostName.PLANHUB]: planhub,
}

export const loadingGifsMap: Record<string, string> = {
  [LoadingGifs.BLACK]: transparentBlackSpinner,
  [LoadingGifs.DARK_BLUE]: transparentDarkBlueSpinner,
  [LoadingGifs.WHITE]: transparentWhiteSpinner,
}

export enum QuestionType {
  ANDROID_APP = 'android-app',
  CHOICE = 'choice',
  CHOICE_BOXES = 'choice-boxes',
  CHOICE_AS_MULTISELECT_PILLS = 'choice-as-multiselect-pills',
  CHOICE_AS_MULTISELECT_DEFAULT = 'choice-as-multiselect-default',
  CHOICE_AS_IMAGES = 'choice-as-images',
  CHOICE_AS_PILLS = 'choice-as-pills',
  CHOICE_AS_PILLS_IMAGE = 'choice-as-pills-image',
  CHOICE_AS_PILLS_LARGE = 'choice-as-pills-large',
  CHOICE_AS_PILLS_EXTRA_LARGE = 'choice-as-pills-extra-large',
  CHOICE_AS_PILLS_LARGE_WITH_OPTIONS = 'choice-as-pills-large-with-options',
  CHOICE_AS_PILLS_LARGE_WITH_TOGGLE_OPTION = 'choice-as-pills-large-with-toggle-option',
  CHOICE_AS_PILLS_VERTICAL = 'choice-as-pill-vertical',
  MIXED_CHOICE_WITH_PILLS_LARGE = 'mixed-choice-with-pills-large',
  MIXED_CHOICE_WITH_PILLS_LARGE_PROVINCE = 'mixed-choice-with-pills-large-province',
  MIXED_CHOICE_WITH_PILLS_LARGE_DECISION = 'mixed-choice-with-pills-large-decision',
  NONE = 'none',
  POSTAL_CODE_INTERNET = 'postal-code-internet',
  POSTAL_CODE_INTERNET_USAGE = 'postal-code-internet-usage',
  POSTAL_CODE_STANDALONE = 'postal-code-standalone',
  INPUT_DEFAULT = 'input-default',
  INPUT_PHONE = 'input-phone',
  INPUT_AUTOCOMPLETE = 'input-autocomplete',
  GOOGLE_AUTOCOMPLETE = 'google-autocomplete',
  INPUT_CURRENCY = 'input-currency',
  INPUT_SAVINGS = 'input-savings',
  STARS = 'stars',
  TEXTAREA = 'textarea',
  TEXTAREA_REFERRAL_CODE = 'textarea-referral-code',
  RADIO_CONFIRM = 'radio-confirm',
  EMAIL = 'email',
  CHOICE_AS_MAIN_PILL = 'choice-as-main-pill',
  CHOICE_AS_MAIN_PILL_ADDITIONAL_BUTTON = 'choice-as-main-pill-additional-button',
  LEAD = 'lead',
  ALERT_CRITERIA = 'alert-criteria',
  SLIDER = 'slider',
  SLIDER_DATA = 'slider-data',
  PROVIDER_AVAILABILITY = 'provider-availability',
  INTERNET_USAGE_INFO_ONLY = 'intenet-usage-info-only',
  POSTAL_CODE_FIBER_OPTIC = 'postal-code-fiber-optic',
  RADIO_DEFAULT = 'radio-button-default',
  CHECKBOX_CONFIRM = 'checkbox-confirm',
  INPUT_DATE_PICKER = 'input-date-picker',
  INPUT_AUTOCOMPLETE_COUNTRY = 'input-autocomplete-country',
  CHECKBOX_CONFIRM_VISITOR = 'checkbox-confirm-visitor',
  NEW_CLIENT_VERIFICATION = 'new-client-verification',
  MULTICHOICE_AS_CHECKBOXES = 'multichoice-as-checkboxes',
}

export enum ProviderType {
  MOBILE = 'mobile',
  INTERNET = 'internet',
}

export enum QuestionGroup {
  DEFAULT = 'default',
  PHONE_SPECS = 'phone-specs',
  REVIEWS = 'reviews',
  LEAD = 'lead',
  CHECK_AVAILABILITY = 'check-availability',
  ALERT = 'alert',
  NEWSLETTER = 'newsletter',
  DECISION = 'decision',
  DECISION_ALERT = 'decision-alert',
}

export type StepId = AllSteps

export enum StepDirection {
  FORWARD = 'forward',
  BACKWARD = 'backward',
}

export enum SortOption {
  POPULARITY = 'popularity',
  PHONE_PRICE = 'phone-price',
  PHONE_NAME = 'phone-name',
  MEMORY_SIZE = 'memory-size',
}

export enum SortOptionCondensed {
  POPULARITY = 'popularity',
  PHONE_PRICE = 'phone-price',
  PHONE_NAME = 'phone-name',
}

export interface CurrentStepState {
  current?: StepId
  direction: StepDirection
  previous: Array<StepId>
  next: Array<StepId>
}

export interface Choice {
  label: string
  value: string
  isChecked?: boolean
  group?: string
}

export interface Scenario {
  id: string
  initialStep: StepId
  version: string
  milestones: Array<StepId>
  type?: ScenarioType
  initialInformation?: Record<string, any>
  steps: Array<ScenarioStep>
  weight?: number
  restrictions?: Array<string>
}

export enum ScenarioType {
  MOBILE = 'mobile',
  INTERNET = 'internet',
  CLIENT_INFO_INTERNET = 'client-info-internet',
  MOBILE_REVIEWS = 'mobile-reviews',
  INTERNET_REVIEWS = 'internet-reviews',
  LEAD_MOBILE = 'lead-mobile',
  LEAD_INTERNET = 'lead-internet',
  CHECK_AVAILABILITY = 'check availability',
  MOBILE_ALERT = 'mobile-alert',
  INTERNET_ALERT = 'internet-alert',
  FIBER_OPTIC_ALERT = 'fiber-optic-alert',
  MOBILE_SEARCH_EMAIL = 'mobile-search-email',
  COMPETITION_INTERNET_ALERT = 'competition-internet-alert',
  ADVISE_INTERNET = 'advise-internet',
  NEWSLETTER = 'newsletter',
  DECISION = 'decision',
  DECISION_ALERT = 'decision-alert',
  DECISION_REVIEW_CONTEST = 'decision-review-contest',
  QUICK_SEARCH_MOBILE = 'quick-search-mobile',
  TICKET = 'ticket',
  MOBILE_ALERT_OBSERVER = 'mobile-alert-observer',
  INTERNET_ALERT_OBSERVER = 'internet-alert-observer',
  INTERNET_SPEED = 'internet-speed',
  CANADA_VISITOR = 'canada-visitor',
  B2B = 'b2b',
  EMAIL_PAGE_GO_INTERNET = 'email-page-go-internet',
  EMAIL_PAGE_GO_MOBILE = 'email-page-go-mobile',
  COUNTRY = 'country',
  MOBILE_REVIEWS_AWARD = 'mobile-reviews-award',
  INTERNET_REVIEWS_AWARD = 'internet-reviews-award',
  EMAIL_COLLECTOR = 'email-collector',
  PHONE_SEARCH = 'phone-search',
  GOVERNMENT_EMPLOYEE = 'government-employee',
}

export enum CurrentProviderCookieNameType {
  CURRENT_MOBILE_PROVIDER = 'currentMobileProvider',
  CURRENT_INTERNET_PROVIDER = 'currentInternetProvider',
}

export enum ScenarioStepModifiableElements {
  QUESTION = 'question',
  TIP = 'tip',
  NEXT = 'next',
  ANSWER_PLACEHOLDER = 'answer-placeholder',
  ANSWERS = 'answers',
  CLEARS = 'clears',
}

type ResourceTranslations = keyof typeof resources[Language.en]['translation'] &
  keyof typeof resources[Language.fr]['translation']

export type Translatable<T = ResourceTranslations> = T | { key: T; options: Record<string, unknown> }

export interface ScenarioStep {
  id: StepId
  question?: Translatable<`${AllSteps}_question`>
  tip?: Translatable<`${AllSteps}_tip`>
  type: QuestionType
  group: string
  metadata?: StepMetadata
  next?: StepId
  answerPlaceholder?: Translatable<`${AllSteps}_answerPlaceholder`>
  answersProvider?: AnswersProviders | AnswersProviderWithOptions
  answers: Array<Answer>
  clears?: Array<StepId>
}

export interface StepMetadata {
  image?: string
  [key: string]: unknown
}

export type AnswerId = string

export interface Answer {
  id: string
  text: Translatable
  next?: StepId
  value?: string
  autoFillAnswers?: Answers
  metadata?: StepMetadata
}

export type Answers = Partial<Record<AllSteps, AnswerId[]>>

export type UNLIMITED_DATA = 'unlimited-data'

export interface CountryInfo {
  EN: string
}

export interface ProviderInfo {
  slugEn: string
  nameEn: string
}
